export default "__VITE_ASSET__DDQxNV6i__"